import LocalizedStrings from "react-localization";

export const mediaClassificationStrings = new LocalizedStrings({
  en: {
    title: "Media Classification",
    leftPanelTitle: "Audience Domains",
    listingTitle: "Title Search",
    domainPlaceholder: "Search by domain name...",
    mediaIdPlaceholder: "Search by Source Id...",
    mediaLabelPlaceholder: "Search by title...",
    search: "Search",
    reset: "Reset",
    map: "Map",
    reject: "Reject",
    all: "All",
    notMapped: "Not mapped",
    validated: "Validated",
    rejected: "Rejected",
    domain: "Domain",
    media: "Title",
    id: "Source Id",
    status: "Status",
    mappedMedia: "Mapped Title",
    selectedDomain: "Selected domain",
    selectDisplayType: "Select a display type to load domains.",
    displayType: "Display type",
    mappingStatus: "Mapping status",
  },
  fr: {
    title: "Classification Média",
    leftPanelTitle: "Domaines Audience",
    listingTitle: "Recherche de Titre",
    domainPlaceholder: "Rechercher par nom de domaine...",
    mediaIdPlaceholder: "Rechercher par Source Id...",
    mediaLabelPlaceholder: "Rechercher par titre...",
    search: "Rechercher",
    reset: "Réinitialiser",
    map: "Mapper",
    reject: "Rejeter",
    all: "Tous",
    notMapped: "Non mappé",
    validated: "Validé",
    rejected: "Rejeté",
    domain: "Domaine",
    media: "Titre",
    id: "Source Id",
    status: "Statut",
    mappedMedia: "Titre mappé",
    selectedDomain: "Domaine sélectionné",
    selectDisplayType:
      "Sélectionnez un type d'affichage pour charger les domaines.",
    displayType: "Type d'affichage",
    mappingStatus: "Statut de mapping",
  },
});
